export default {
  en: {
    pageTitles: {
      assessment: 'Assessment',
      assessmentWizard: 'Assessment wizard',
      assessmentOverview: 'Assessment overview',
      bizapproval: "{company}'s business approval",
      clients: 'Clients',
      dashboard: 'Dashboard',
      discussions: 'Discussions',
      godGraph: 'Network graph',
      policies: 'Policies',
      quickConnect: 'Quick connect',
      scopingQuestions: 'Scoping questions',
      clientReporting: {
        compliance: 'Compliance reporting',
        activity: 'Activity reporting',
        performance: 'Performance reporting',
        risk: 'Risk reporting',
      },
      settings: 'Settings',
      suppliers: 'Suppliers',
      wizard: 'Wizard',
    },
    systemUser: 'System user',
    deletedUser: 'Deleted user',
    justNow: 'just now',
    genericError: 'An error has occurred. Try again or {contactSupport}.',
    genericErrorContactSupport: 'contact support',
    learnMore: 'Learn more',
    validation: {
      required: 'Enter a value',
      url: 'Enter a valid URL',
      password: 'Password does not meet requirements',
      confirmPassword: 'Passwords do not match',
      invalidPhone: 'Enter a valid phone number',
      leadModePermissions: 'Lead user must have client and supplier mode permission',
      invalidDomain: 'Enter a valid domain',
    },
    cta: {
      cancel: 'Cancel',
      close: 'Close',
      saveChanges: 'Save changes',
    },
    restrictions: {
      supplierRestrictionDescription:
        'You are only shown information relevant to your assigned suppliers.',
    },
  },
};
